module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-field"
  }, [(_vm.field.templateOptions.label) ? _c('label', {
    staticClass: "list-field-label"
  }, [_vm._v(_vm._s(_vm.field.templateOptions.label))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-plus list-field-add",
    on: {
      "click": function($event) {
        _vm.pushNew()
      }
    }
  }), _vm._v(" "), _c('draggable', {
    staticClass: "list-field-draggable-sort",
    attrs: {
      "options": {
        handle: '.handle'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.model[_vm.field.key]),
      callback: function($$v) {
        _vm.$set(_vm.model, _vm.field.key, $$v)
      },
      expression: "model[field.key]"
    }
  }, _vm._l((_vm.model[_vm.field.key]), function(modelinstance, index) {
    return _c('div', {
      staticClass: "list-field-item"
    }, [_c('formly-form', {
      attrs: {
        "form": _vm.form,
        "model": _vm.model,
        "fields": _vm.getSubfields(index)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "glyphicon glyphicon-resize-vertical handle"
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cec49122"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/elements/ListRepeater.vue
// module id = 1117
// module chunks = 0